import { useState } from "react";
import {
  Heading,
  Container,
  Stack,
  Center,
  Spinner,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Text,
} from "@chakra-ui/react";
import Layout from "@/components/Layout";
import Header from "components/Header";
import BlogCard from "@/components/BlogCard";
import NoContent from "@/components/NoContent";
import { formatToBlogDate } from "utils/helpers";
import StyledButton from "@/components/StyledButton";
import { getPosts } from "utils/blogApi";
import { BLOG_PAGE_SIZE, DEFAULT_OFFSET } from "utils/constants";
import { FiArrowDown } from "react-icons/fi";
import { ChevronRightIcon } from "@chakra-ui/icons";

const Blog = ({ initialPosts }) => {
  const [posts, setPosts] = useState(initialPosts);
  const [offset, setOffset] = useState(BLOG_PAGE_SIZE);
  const [hasMoreData, setHasMoreData] = useState(
    () => initialPosts.length === BLOG_PAGE_SIZE + 1
  );
  const [isLoading, setIsLoading] = useState(false);

  const handleLoadMore = async () => {
    try {
      setIsLoading(true);
      const newPosts = await getPosts(10, offset);
      if (newPosts.length < BLOG_PAGE_SIZE) {
        setHasMoreData(false);
      }
      setPosts((prev) => [...prev, ...newPosts]);
      setOffset(offset + BLOG_PAGE_SIZE);
    } catch (error) {
      setHasMoreData(false);
    } finally {
      setIsLoading(true);
    }
  };

  return (
    <Layout>
      <Header browserTitle="WellFitly Blog" />
      <Container maxW={"7xl"} minH={"100vh"} p="6">
        <Heading fontFamily={"Yeseva"} as="h1">
          Wellness & Fitness Blog
        </Heading>
        <Breadcrumb
          spacing="8px"
          separator={<ChevronRightIcon color="gray.500" />}
        >
          <BreadcrumbItem>
            <BreadcrumbLink href="/">Home</BreadcrumbLink>
          </BreadcrumbItem>

          <BreadcrumbItem>
            <Text>WellFitly Blog</Text>
          </BreadcrumbItem>
        </Breadcrumb>
        <Stack py={6}>
          {posts ? (
            posts.map((post) => <BlogCard key={post.id} post={post}></BlogCard>)
          ) : (
            <NoContent text={"Nothing has been published yet."} />
          )}
        </Stack>
        {hasMoreData ? (
          <Stack py={10}>
            <Center>
              <StyledButton
                rightIcon={isLoading ? <Spinner /> : <FiArrowDown />}
                text={
                  isLoading ? "Loading more articles..." : "View More Articles"
                }
                onClick={handleLoadMore}
                isLoading={isLoading}
                disabled={!hasMoreData || isLoading}
              />
            </Center>
          </Stack>
        ) : null}
      </Container>
    </Layout>
  );
};

export default Blog;

export async function getStaticProps() {
  const posts = await getPosts(BLOG_PAGE_SIZE, DEFAULT_OFFSET);
  const initialPosts = posts.map((post) => ({
    ...post,
    created_at: formatToBlogDate(post.created_at),
  }));
  return {
    props: { initialPosts },
    revalidate: 900,
  };
}
